import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import "./index.css";
import { Layout } from "./components/Layout";
import { Queue } from "./pages/Queue";
import { Holds } from "./pages/Holds";
import { Imported } from "./pages/Imported";
import { Processing } from "./pages/Processing";
import { Rejected } from "./pages/Rejected";
import { Reports } from "./pages/Reports";
import { Review } from "./pages/Review";
import { Settings } from "./pages/Settings";
import { Upload } from "./pages/Upload";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<Reports />} />
          <Route path="/review-queue" element={<Queue />} />
          <Route path="/upload" element={<Upload />} />
          <Route path="/holds" element={<Holds />} />
          <Route path="/processing" element={<Processing />} />
          <Route path="/imported" element={<Imported />} />
          <Route path="/rejected" element={<Rejected />} />
          <Route path="/review/:rxId" element={<Review />} />
          <Route path="/settings" element={<Settings />} />
          {/* Legacy redirects */}
          <Route path="/queue" element={<Navigate to="/review-queue" replace />} />
          <Route path="/reports" element={<Navigate to="/" replace />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Route>
      </Routes>
    </BrowserRouter>
  </React.StrictMode>,
);
